import _Object$assign from 'babel-runtime/core-js/object/assign';

var NAMESPACE = 'td';

var Input = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _vm.type === 'textarea' ? _c('label', { staticClass: "td-textarea", class: { 'is-warn': _vm.warn, 'is-disabled': _vm.disabled } }, [_c('span', { staticClass: "td-textarea__label" }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('textarea', _vm._g(_vm._b({ ref: "input", staticClass: "td-textarea__inner", attrs: { "disabled": _vm.disabled }, domProps: { "value": _vm.value } }, 'textarea', _vm.$attrs, false), _vm.inputListeners))]) : _c('label', { staticClass: "td-input", class: { 'is-warn': _vm.warn, 'is-disabled': _vm.disabled } }, [_c('span', { staticClass: "td-input__label" }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', _vm._g(_vm._b({ ref: "input", staticClass: "td-input__inner", attrs: { "type": _vm.type, "disabled": _vm.disabled }, domProps: { "value": _vm.value } }, 'input', _vm.$attrs, false), _vm.inputListeners))]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-input',

  inheritAttrs: false,

  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: [Number, String],
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    warn: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    inputListeners: function inputListeners() {
      return _Object$assign({}, this.$listeners, {
        input: this.handleInput
      });
    }
  },

  methods: {
    select: function select() {
      this.$refs.input.select();
    },
    handleInput: function handleInput(e) {
      this.$emit('input', e.target.value);
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.autofocus) {
        _this.$refs.input.focus();
      }
    });
  }
};

Input.install = function (Vue) {
  Vue.component(Input.name, Input);
};

export default Input;
